<div class="centera">
	<ion-button class="ion-no-padding btn-ctct" (click)="action()" [ngClass]="params.cssClass" color="action-button"
		slot="icon-only" [fill]="params.fill ? params.fill : 'solid'" data-cy="action-button" [shape]="params.shape">
		<ion-icon class="txt24px" [name]="icon"></ion-icon>
	</ion-button>
	<span [class]="model.externalId ? 'exported' : 'not-exported'">{{ model.externalId ? '✓' : '✕' }}</span>
	<ion-note *ngIf="label" class="action-button-text">{{label}}</ion-note>
</div>